import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { useRouteParams } from '../hooks/useRouteParams';

interface FetcherParams {
  clientId: string;
  accountId: string;
  groupId: string;
}

export interface DistributionAccountDTO {
  name: string;
  accountNumber: string | null;
  ytdDistribution: number;
  total: number;
  remaining: number;
}

interface DistributionDTO {
  isRegistrationGrouping: boolean;
  accounts: DistributionAccountDTO[];
}

const fetchRmdDashboard = ({
  clientId,
  accountId,
  groupId,
}: FetcherParams): Promise<DistributionDTO> => {
  return authFetch(
    urlWithParams('/Consumer/OrionAccountsWidgets/RmdSummary', { clientId, accountId, groupId }),
  );
};

export const useRmdDashboardQuery = () => {
  const { clientId, accountId, groupId } = useRouteParams();

  return useQuery(
    queryKeys.rmdDashboard(clientId, accountId, groupId),

    () => fetchRmdDashboard({ clientId, accountId, groupId }),

    {
      cacheTime: 0,
    },
  );
};
